import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=5220f27e&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "./Register.vue?vue&type=style&index=0&id=5220f27e&prod&lang=scss&scoped=true&"
import style1 from "./Register.vue?vue&type=style&index=1&id=5220f27e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5220f27e",
  null
  
)

export default component.exports